import { X } from 'lucide-react';
import { AddProspectAccountInline } from '../AddProspectAccountInline';

/**
 * Prompt shown when clicking a Contractor company that isn't linked to a
 * real Zoho Account yet — creates one via the existing Add Prospect flow,
 * then links it back onto the Spellers account row.
 */
export const SpellersLinkCrmModal = ({ account, onClose, onLinked }) => {
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/40 p-4" data-testid="spellers-link-crm-modal">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-5">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-bold text-gray-900">Not in CRM yet</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-testid="spellers-link-crm-close">
            <X className="w-5 h-5" />
          </button>
        </div>
        <p className="text-sm text-gray-500 mb-3">
          "{account.company}" isn't linked to a Zoho Account yet. Create it below to add this contractor to the CRM.
        </p>
        <AddProspectAccountInline
          initialPhone={account.telephone || ''}
          initialAccountName={account.company || ''}
          onCreated={({ account: zohoAccount }) => onLinked(zohoAccount)}
          onCancel={onClose}
        />
      </div>
    </div>
  );
};

export default SpellersLinkCrmModal;
